import { Button, Dialog, IconButton } from '@material-ui/core';
import { XIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { BORDER, createAdminPageStyles, MUTED, NAVY, TEXT } from '../../style';

interface ConfirmActionModalProps {
  open: boolean;
  title: string;
  text: string;
  confirmLabel: string;
  confirming?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const useStyles = createAdminPageStyles({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      maxWidth: 560,
      width: '100%',
      margin: 16,
      padding: '28px 32px 24px',
      boxShadow: '0 16px 40px rgba(14, 18, 71, 0.18)',
    },
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 12,
  },
  dialogTitle: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 600,
    color: '#000B33',
    margin: 0,
    lineHeight: 1.3,
  },
  dialogClose: {
    margin: '-8px -8px 0 0',
    color: TEXT,
    padding: 6,
  },
  dialogText: {
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 400,
    color: TEXT,
    lineHeight: 1.5,
    margin: '0 0 24px',
  },
  actions: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
  },
  cancelBtn: {
    background: '#FFFFFF',
    color: NAVY,
    border: `1.5px solid ${BORDER}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 15,
    borderRadius: 8,
    padding: '12px 16px',
    boxShadow: 'none',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
    '&:disabled': {
      color: MUTED,
    },
  },
  confirmBtn: {
    background: '#000A8D',
    color: '#FFFFFF',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 15,
    borderRadius: 8,
    padding: '12px 16px',
    boxShadow: 'none',
    '&:hover': {
      background: '#1b2158',
      boxShadow: 'none',
    },
    '&:disabled': {
      background: '#E8EAF0',
      color: MUTED,
    },
  },
});

const ConfirmActionModal: FC<ConfirmActionModalProps> = ({
  open,
  title,
  text,
  confirmLabel,
  confirming = false,
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={confirming ? undefined : onClose}
      className={classes.dialog}
      aria-labelledby="confirm-action-title">
      <div className={classes.dialogHeader}>
        <h2 id="confirm-action-title" className={classes.dialogTitle}>
          {title}
        </h2>
        <IconButton
          aria-label="Fermer"
          className={classes.dialogClose}
          onClick={onClose}
          disabled={confirming}>
          <XIcon size={20} />
        </IconButton>
      </div>

      <p className={classes.dialogText}>{text}</p>

      <div className={classes.actions}>
        <Button className={classes.cancelBtn} onClick={onClose} disabled={confirming}>
          Annuler
        </Button>
        <Button className={classes.confirmBtn} onClick={onConfirm} disabled={confirming}>
          {confirming ? 'Chargement...' : confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
};

export default ConfirmActionModal;
